export enum GeneratorModelState {
	ACTIVE = 'ACTIVE',
	DISPATCHED = 'DISPATCHED'
}
